import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';

@Injectable()
export class VerifyPhoneNumberService {

  constructor(private http: HttpClient) {}

  checkPhoneNumberExists(phone: string): Observable<{is_present: boolean}>{
    return this.http.get<{is_present: boolean}>(`${environment.apiEndpoint}/api/v1/dids/by-number/${phone}/presence`)
  }
}